import { Routes, RouterModule } from '@angular/router';
import {
  MainLayoutComponent,
  AuthLayoutComponent,
} from 'shared-angular-components-avla';
import { ModuleWithProviders } from '@angular/core';
import { AuthService } from 'base-angular-avla';

export const routes: Routes = [
  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
  {
    path: 'errorsLogout',
    loadChildren: () =>
      import(
        'shared-angular-components-avla/+miscellaneous/miscellaneous.module'
      ).then(m => m.MiscellaneousModule),
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('shared-angular-components-avla/+auth/auth.module').then(
        m => m.AuthModule
      ),
    data: { mode: false },
  },
  {
    path: '',
    component: MainLayoutComponent,
    data: { pageTitle: 'Mark-list - AVLA', mode: false, isLogo: true },
    loadChildren: () => import('./views/views.module').then(m => m.ViewsModule),
    canActivate: [AuthService],
  },

  {
    /* ESTE SIEMPRE DEBE IR AL FINAL DEL LISTADO!!! */ path: '**',
    redirectTo: '/errorsLogout/error404',
  },
  //
];

export const routing: ModuleWithProviders<any> = RouterModule.forRoot(routes, {
  useHash: true
});
